import { render, staticRenderFns } from "./App3Pyramid.vue?vue&type=template&id=e377d08a&scoped=true&"
import script from "./App3Pyramid.vue?vue&type=script&lang=js&"
export * from "./App3Pyramid.vue?vue&type=script&lang=js&"
import style0 from "./App3Pyramid.vue?vue&type=style&index=0&id=e377d08a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e377d08a",
  null
  
)

export default component.exports